
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/introducing-mui-v9",
      function () {
        return require("private-next-pages/blog/introducing-mui-v9.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/introducing-mui-v9"])
      });
    }
  